import { render, staticRenderFns } from "./TabSelect.vue?vue&type=template&id=6b54dd2a&scoped=true"
import script from "./TabSelect.vue?vue&type=script&lang=js"
export * from "./TabSelect.vue?vue&type=script&lang=js"
import style0 from "./TabSelect.vue?vue&type=style&index=0&id=6b54dd2a&prod&lang=scss&scoped=true&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54dd2a",
  null
  
)

export default component.exports